import Cookie from 'js-cookie';

export function getPersistentUuid (cookieName = 'gb_uuid', expires = 400) {
  const persistedUuid = Cookie.get(cookieName);

  if (persistedUuid) {
    return persistedUuid;
  }

  const uuid = generateUuid();
  Cookie.set(cookieName, uuid, { expires });

  return uuid;
}

export function generateUuid() {
  if (window?.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return _uuidv4();
}

export function _uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
